/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ahu_History_Key_Supplyaircoolingactualsetpoint4Inputs */



/**
* | output |
* | --- |
* | "Supply air cooling actual setpoint" |
*
* @param {Ahu_History_Key_Supplyaircoolingactualsetpoint4Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const ahu_history_key_supplyaircoolingactualsetpoint4 = /** @type {((inputs?: Ahu_History_Key_Supplyaircoolingactualsetpoint4Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ahu_History_Key_Supplyaircoolingactualsetpoint4Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Supply air cooling actual setpoint")
	return /** @type {LocalizedString} */ ("Consigne réelle froid air soufflé")
});
export { ahu_history_key_supplyaircoolingactualsetpoint4 as "ahu_history_key_supplyAirCoolingActualSetpoint" }